/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */
import { getTravelParams } from '../../constants/apiRequest/requestConstants/endpoints';
import { makeRequest } from '../../helpers/makeApiRequest';


export const getTravelResources = async (props = {}) => {
  return await makeRequest({
    method: 'GET',
    url: getTravelParams,
    history: props.history
  });
};
